// Generated by scripts/exam/build.mjs.
export const EXAM_EXPLANATION_ROOT = '/explanations/exam-ja-v1-c342f6d24492';
//# sourceMappingURL=exam-explanation-config.js.map